import {RouteInfo} from "../components/navbar/navbar.component";

export class Menu{
  menu:RouteInfo[];
}
